import React from 'react';
import { ScrollView, DataGrid, Button, Popup } from 'devextreme-react';
import { Column, Pager, Paging } from 'devextreme-react/data-grid';
import { FormatLineNumber } from '../../common';

const CorpListSelectedInfoPopup = ({
  onHiding,
  onClickDelete,
  selectedInfoList,
  visibleSelectedInfoPopup,
}) => {
  // console.log('CorpListSelectedInfoPopup Load');

  return (
    <div>
      <React.Fragment>
        <Popup
          title="법인 해지고객 리스트"
          visible={visibleSelectedInfoPopup}
          onHiding={onHiding}
          className="popup"
          height="90vh"
        >
          <ScrollView>
            <div className="corp-list-selected-info-content popup-content">
              <DataGrid
                className={'dx-card wide-card'}
                dataSource={selectedInfoList}
                showBorders={true}
                focusedRowEnabled={false}
                columnAutoWidth={true}
                width="100%"
                height="100%"
              >
                <Column dataField="Name" caption="성명" alignment="center" />
                <Column
                  dataField="LineNumber"
                  caption="전화번호"
                  alignment="center"
                  customizeText={(e) => FormatLineNumber(e.value)}
                />
                <Column dataField="Part" caption="부서" alignment="center" />
                <Column
                  dataField="UseCheckName"
                  caption="이용한도"
                  alignment="center"
                />
                <Paging defaultPageSize={10} />
                <Pager showPageSizeSelector={true} showInfo={true} />
              </DataGrid>
            </div>
            <div className="corp-list-selected-info-bottom">
              <Button
                stylingMode="contained"
                type="danger"
                text="등록해지"
                onClick={onClickDelete}
              />
              <Button
                stylingMode="contained"
                type="normal"
                text="닫기"
                onClick={onHiding}
              />
            </div>
          </ScrollView>
        </Popup>
      </React.Fragment>
    </div>
  );
};

export default React.memo(CorpListSelectedInfoPopup);
